// extracted by mini-css-extract-plugin
export default {"primaryInfo":"styles-module__primaryInfo__src-labstep-web-components-User-Show-Settings-_jB67F"};